// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","main":"App_main__nhgh3"};